module.exports = __webpack_public_path__ + "10054ca546699075707a0b0d5e670c43.svg";